import { render, staticRenderFns } from "./recommendUpdate.vue?vue&type=template&id=59665949"
import script from "./recommendUpdate.vue?vue&type=script&lang=js"
export * from "./recommendUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports